module.exports = __webpack_public_path__ + "static/img/step-0.a3699a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/tuto-unlock-popup/chrome/step-0.png
// module id = 949
// module chunks = 0